<template>
  <div>
    <b-modal
      id="modal-import-file"
      size="md"
      ref="modalImportFile"
      title="Импорт заявки из файла"
      :ok-only="false"
      :no-fade="true"
      @ok="okHandler"
      @cancel="cancelHandler"
      @close="cancelHandler"
      @hide="cancelHandler"
      button-size="sm"
      ok-title="Импортировать"
      ok-variant="primary"
      cancel-title="Отменить"
    >
      <b-list-group horizontal>
        <b-form-file size="sm" class="mr-1" v-model="importFile" accept="" browse-text="Выбрать" placeholder="Файл не выбран"/>
        <b-button size="sm" variant="danger" @click="importFile = null">
          <font-awesome-icon icon="times"/>
        </b-button>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import tasks from "../../network/tasks";
import locations from "../../network/locations";
import users from "../../network/users";
import workers from "../../network/workers";
import customers from "../../network/customers";
  import dateFormatter from "../../utilites/dateFormatter";
  import * as XLSX from "xlsx";
  import moment from 'moment';
  import taskService from "./taskService";

export default {
  name: "TasksImport",
  mixins: [
    tasks, locations, users, workers, customers,
    dateFormatter, taskService
  ],
  data() {
    return {
      callback: null,
      importFile: null,
      user: null
    }
  },
  methods: {
    async show(callback) {
      this.callback = callback;
      this.$refs.modalImportFile.show();
      this.user = (await this.getUserInfo()).data;
    },
    hide() {
      this.$refs.modalImportFile.hide();
      this.importFile = null;
    },
    async okHandler() {
      if (this.callback !== null) {
        const data = await this.readExcel();
        await this.handleData(data);
        this.callback();
      }

      this.hide();
    },
    cancelHandler() {
      this.importFile = null;
    },
    async readExcel() {
      const file = this.importFile;
      const blob = new Blob([file]);
      const buffer = await blob.arrayBuffer();
      const wb = XLSX.read(buffer);
      const ws = wb.Sheets[wb.SheetNames[0]];

      return XLSX.utils.sheet_to_json(ws);
    },
    async handleData(data) {
      const locations = this.aggregate(data, "location_id", "tasks");

      for (const item of locations) {
        item.tasks = this.aggregate(item.tasks, "start_date", "workers");

        // Получаем Заказчика по id объекта
        const locationDTO = (await this.getLocationById(item.location_id)).data;

        if (locationDTO != null) {
          for (let task of item.tasks) {
            const workers = task.workers;
            if (workers.length > 0) {
              const worker = workers[0];
              const format = "DD.MM.YYYY HH:mm:ss"
              const mStartDate = moment(worker.start_date, format).toDate();
              const mEndDate = moment(worker.end_date, format).toDate();
              const startDate = this.formatServerDate(mStartDate);
              const endDate = this.formatServerDate(mEndDate);

              task.location_id = worker.location_id;
              task.start_date = startDate;
              task.end_date = endDate;
              task.town = worker.town;
              task.price = worker.price;
              task.customer_id = locationDTO.customer_id;
              task.start_address = locationDTO.address;
              task.payment_type = worker.payment_type;
            }
          }
        }
      }

      // Проходим по списку объектов
      for (let location of locations) {
        // Проходим по списку заявок
        for (let task of location.tasks) {
          let tws = [];
          // Проходим по списку работников
          for (let worker of task.workers) {
            const workerDTO = await this.getWorker(worker.worker_id);
            // Пропускаем не найденных работников
            if (workerDTO != null) {
              // Заполняем рабтников для заявки
              const tw = this.makeWorker(workerDTO, worker, task);
              tws.push(tw);
            }
          }

          const customer = (await this.getCustomerById(task.customer_id)).data;
          // Заполняем заявку
          const newItem = this.makeTask(task, tws, customer);

          await this.createTask(newItem);

        }
      }
    },
    async getWorker(id) {
      return (await this.getWorkerById(id)).data;
    },
    async createTask(task) {
      this.isBusy = true;
      const taskResult = await this.postTask(task);
      this.isBusy = false;
      if (taskResult.error !== undefined) {
        // TODO: Handle Error
        return;
      }
      if (taskResult.data === undefined) {
        // TODO: Handle Error
        return;
      }
    },
    makeWorker(workerDTO, worker, task) {
      let tw =  {
        worker_id: workerDTO.id,
        price: worker.worker_price,
        total_price: 0,
        dinner: 0,
        description: worker.worker_description,
        start_date: task.start_date,
        end_date: task.end_date,
        paid: Boolean(worker.worker_paid),
        worker: workerDTO,
        total_units: worker.worker_total_units
      };

      tw.total_price = this.calculateTotalWorkerPrice(tw);

      return tw;
    },
    makeTask(task, tws, customer) {
      const userId = this.user.id;
      const executorRate = this.calculateExecutorRate(task.payment_type, this.user);
      const coordinatorRate = 0;

      const totalHours = this.calculateWorkersHours(tws);
      const totalWorkerPrice = this.calculateWorkersPrice(tws);

      const result = {
        start_address: task.start_address,
        end_address: '',
        start_date: task.start_date,
        end_date: task.end_date,
        payment_type_int: task.payment_type,
        payment_first_count: 0,
        payment_first: task.price,
        payment_second_count: 0,
        payment_second: 0,
        workers_count: 0,
        total_hours: totalHours,
        total_price: 0, // считаем ниже
        total_worker_price: totalWorkerPrice,
        total_delta: 0, // считаем ниже
        total_manager: 0, // считаем ниже
        additional_cost: 0,
        additional_income: 0,
        description: '',
        cargo_description: '',
        customer_id: task.customer_id,
        customer_name: '',
        author: userId,
        executor: userId,
        paid: false,
        contact: '',
        declarated_cost: 0,
        task_workers: tws,
        location_id: task.location_id,
        read_only: false,
        executor_rate: executorRate,
        coordinator: userId,
        coordinator_rate: coordinatorRate,
        total_coordinator: 0, // считаем ниже
        status_id: 1,
        town_id: task.town,
        work_type_id: 1,
        unit_code: "539"
      }

      result.total_price = this.calculateTotalPrice(result);
      result.total_delta = this.calculateTotalDelta(result);
      result.total_manager = this.calculateTotalDeltaWithRate(result.total_delta, executorRate);
      result.total_coordinator = this.calculateTotalDeltaWithRate(result.total_delta, coordinatorRate);

      return result;
    },
    aggregate(arr, on, who) {
      const agg = arr.reduce((a, b) => {
        const onValue = b[on];
        //delete b[on];
        const whoValue = b;

        // if there is already a key present merge its value
        if(a[onValue]) {
          a[onValue] = {
            [on]: onValue,
            [who]: [...a[onValue][who], whoValue]
          }
        }  else {
          // create a new entry on the key
          a[onValue] = {
            [on]: onValue,
            [who]: [whoValue]
          }
        }
        return a;
      }, {});

      // return only values after aggregation
      return Object.values(agg);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tasks/TasksImport.vue